import { DimensionsUnitsEnum } from '../enums/dimensions-units.enum';

const convertDimensions = (
  value: number | string,
  fromUnit = DimensionsUnitsEnum.MM,
  toUnit = DimensionsUnitsEnum.CM,
): number => {
  const dimensions = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
  if (fromUnit === toUnit) return dimensions;
  if (fromUnit === DimensionsUnitsEnum.MM && toUnit === DimensionsUnitsEnum.CM) {
    return dimensions / 10;
  }
  if (fromUnit === DimensionsUnitsEnum.CM && toUnit === DimensionsUnitsEnum.MM) {
    return dimensions * 10;
  }
  return dimensions;
};

export default convertDimensions;
